// extracted by mini-css-extract-plugin
export default {"toolkit":"LocalizationToolkit_toolkit__Rmjn3"};